import { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { salaryProcessApi, getMonthName } from '../api/salaryProcessApi';
import { appToast } from '../../../../components/AppToast';

export function useSalaryProcessEntry() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const rawMonth = searchParams.get('month') || String(new Date().getMonth() + 1);
  const monthNum = parseInt(rawMonth, 10) || 7;
  const monthLabel = getMonthName(monthNum);
  const year = searchParams.get('year') || String(new Date().getFullYear());

  const company = searchParams.get('company') || 'Tez Educational School';
  const branch = searchParams.get('branch') || '';
  const department = searchParams.get('department') || '';
  const companyId = Number(searchParams.get('companyId') || 0);
  const branchId = Number(searchParams.get('branchId') || 0);
  const deptId = Number(searchParams.get('deptId') || 0);

  const [isProcessing, setIsProcessing] = useState(false);
  const [processProgress, setProcessProgress] = useState(0);

  const handleProcess = async () => {
    setIsProcessing(true);
    setProcessProgress(20);

    try {
      setTimeout(() => setProcessProgress(55), 400);
      setTimeout(() => setProcessProgress(85), 800);

      const res = await salaryProcessApi.processSalary({
        companyId,
        branchId,
        deptId,
        month: monthNum,
        year: Number(year),
      });

      setProcessProgress(100);
      const count = res?.processed_count ?? res?.count ?? 0;
      appToast.success(
        res?.message || `Salary processed successfully for ${count} employees (${monthLabel} ${year})!`
      );

      navigate(`/payroll/salary-process?month=${monthNum}&year=${year}`);
    } catch (err) {
      console.error('Error processing salary:', err);
      const msg =
        err?.response?.data?.detail?.message ||
        (typeof err?.response?.data?.detail === 'string' ? err?.response?.data?.detail : null) ||
        err?.message ||
        'Failed to process salary. Please try again.';
      appToast.error(msg);
    } finally {
      setIsProcessing(false);
    }
  };

  const handleCancel = () => {
    navigate('/payroll/salary-process');
  };

  return {
    state: {
      month: monthLabel,
      monthNum,
      year,
      company,
      branch: branch && branch !== 'Select' ? branch : 'All Branches',
      department: department && department !== 'Select' ? department : 'All Departments',
      isProcessing,
      processProgress,
    },
    actions: {
      handleProcess,
      handleCancel,
    },
  };
}
